module.exports = require('./helpers/bundle-url').getBundleURL('7LnO3') + "../../resources/images/" + require('./helpers/bundle-manifest').resolve("iURjE");